import React from 'react'

type Props = {
  className?: string
}

const Pharmacy = ({ className }: Props) => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" className={className}>
    <path
      d="M42 11.7026H30V7.70264H32V5.70264H16V7.70264H18V11.7026H6C5.448 11.7026 5 12.1506 5 12.7026V41.7026C5 42.2546 5.448 42.7026 6 42.7026H42C42.552 42.7026 43 42.2546 43 41.7026V12.7026C43 12.1506 42.552 11.7026 42 11.7026ZM20 7.70264H28V11.7026H20V7.70264ZM41 40.7026H7V13.7026H41V40.7026Z"
      fill="#2979FF"
    />
    <path
      d="M16 29.7026H21V34.7026C21 35.2546 21.448 35.7026 22 35.7026H26C26.552 35.7026 27 35.2546 27 34.7026V29.7026H32C32.552 29.7026 33 29.2546 33 28.7026V24.7026C33 24.1506 32.552 23.7026 32 23.7026H27V18.7026C27 18.1506 26.552 17.7026 26 17.7026H22C21.448 17.7026 21 18.1506 21 18.7026V23.7026H16C15.448 23.7026 15 24.1506 15 24.7026V28.7026C15 29.2546 15.448 29.7026 16 29.7026ZM17 25.7026H22C22.552 25.7026 23 25.2546 23 24.7026V19.7026H25V24.7026C25 25.2546 25.448 25.7026 26 25.7026H31V27.7026H26C25.448 27.7026 25 28.1506 25 28.7026V33.7026H23V28.7026C23 28.1506 22.552 27.7026 22 27.7026H17V25.7026Z"
      fill="#2979FF"
    />
  </svg>
)

export default Pharmacy
